import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    standalone: true,
    imports: [NgIf, NgClass, FontAwesomeModule, TranslateModule],
    selector: 'qwyk-full-screen-button',
    templateUrl: './full-screen-button.component.html',
    styleUrls: ['./full-screen-button.component.css'],
})
export class FullScreenButtonComponent implements AfterViewInit {
    @Input() element: any;
    @Input() disabled = false;
    @Input() buttonClass = 'btn-outline-primary';
    @Input() textLabel = false;
    @Input() public isFullScreen = false;
    @Output() emitter = new EventEmitter<boolean>();

    private _document: Document;

    ngAfterViewInit() {
        this._document = document;
        if (this._document) {
            this._document.onfullscreenchange = () => {
                this.isFullScreen = !!this._document.fullscreenElement;
                this.emitter.emit(!!this._document.fullscreenElement);
            };
        }
    }

    public get canFullscreen(): boolean {
        const e = this.element;
        return (
            e &&
            (e.requestFullscreen ||
                e.msRequestFullscreen ||
                e.mozRequestFullScreen ||
                e.webkitRequestFullscreen)
        );
    }

    public onToggleFullscreen() {
        const elem = this.element;

        if (!this._document || !elem) {
            return;
        }

        const docWithVendorPrefixes = this._document as any;

        if (this._document.fullscreenElement === null) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            }
        } else {
            if (this._document.exitFullscreen) {
                this._document.exitFullscreen().then();
            } else if (docWithVendorPrefixes.mozCancelFullScreen) {
                /* Firefox */
                docWithVendorPrefixes.mozCancelFullScreen();
            } else if (docWithVendorPrefixes.webkitExitFullscreen) {
                /* Chrome, Safari and Opera */
                docWithVendorPrefixes.webkitExitFullscreen();
            } else if (docWithVendorPrefixes.msExitFullscreen) {
                /* IE/Edge */
                docWithVendorPrefixes.msExitFullscreen();
            }
        }
    }
}
